<ng-container *transloco="let t">
  <div>
    <app-algo-mode-selection
      [selectedAlgoModeConfig]="algoModeConfigInit()"
      [disabled]="updateLoading()"
      (algoModeConfig)="setAlgoModeConfig($event)"
      [suggestedAcosTarget]="suggestedAcosTarget()"
      [currencyCode]="modalData.currencyCode"
    />
    <div class="flex justify-between pt-4">
      <button iButton variant="secondary" size="md" (click)="ref.close()">{{ t("common.cancel") }}</button>
      <button
        iButton
        testId="btn-confirm"
        class="w-2/4"
        size="md"
        [loading]="updateLoading()"
        [disabled]="!selectedAlgoModeConfig?.isValid"
        (click)="update()"
      >
        {{ t("common.save") }}
      </button>
    </div>
  </div>
</ng-container>
